import { DEFAULT_DOMAIN_ESC, ESC_REGIONS } from "./constants/cookie-constants";
import CookieDefinitions from "./definitions/cookie-definitions";

const DOMAINS = {
    NONPROD: /alpha|beta|gamma|integ|preprod|pre-prod|aws-dev|local/i,
    PROD: /aws.amazon.com|amazonaws.cn|amazonaws-us-gov.com|aws.com|amazonaws.eu/i
};

export function update<T>(target: T, source: Partial<T>): T {
    Object.keys(source).forEach(k => {
        target[k] = source[k];
    });
    return target;
}

/**
 * Takes in a NodeList and returns an array so that regular array methods can be used on it;
 * primarily used for IE11 compatibility
 * @param {NodeList} nodeList - The list to be converted to an array
 */
export function convertToArray(nodeList: NodeList): Array<HTMLElement> {
    return Array.prototype.slice.call(nodeList);
}


/**
 * 
 * @returns true if the current environment is production console, false otherwise.
 */
export const isProdConsole = (): boolean => {
    const hostname = window.location.hostname;
    return DOMAINS.PROD.test(hostname) && !DOMAINS.NONPROD.test(hostname);
};

export const isHostnameInGivenDomain = (domain: string): boolean => {
    return window.location.hostname.endsWith(domain);
}

export const isESCPartition = (): boolean => {
    return isHostnameInGivenDomain(DEFAULT_DOMAIN_ESC);
}

/**
 * Checks if the user is currently in an AWS Console session by verifying the presence
 * of ConsoleNavService and its current service ID.
 * @returns true if user is in a console session, false otherwise
 */
export const isConsoleSession = (): boolean => {
    // Type assertion for ConsoleNavService which may exist on window
    const currentWindow = window as any;
    
    if (currentWindow.ConsoleNavService && 
        currentWindow.ConsoleNavService.Model && 
        currentWindow.ConsoleNavService.Model.currentService) {
        return !!currentWindow.ConsoleNavService.Model.currentService.id;
    }
    
    return false;
};


export const isGPCEnabled = (): boolean => (navigator as any).globalPrivacyControl === true;

/**
 * Applies Global Privacy Control over a consent record as a runtime override.
 * Never persisted, so turning the signal off restores the stored preferences.
 */
export const applyGPC = (consent: CookieDefinitions.ConsentCookie): CookieDefinitions.ConsentCookie =>
    isGPCEnabled() ? { ...consent, advertising: false, ccba: false } : consent;
